import * as React from 'react';
import './ProjectLayout.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { RestrictedLayout } from "../../../components/layouts/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { ProjectSubMenu, TrialProjectSubMenu, TrialSubMenu } from '../../../helpers/subMenuHelper';

interface IProjectLayoutProps {
    // From state
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    project?: Dtos.Project;

    loadingProject?: boolean;

    loading?: boolean;
    children?: any;
}

interface IProjectLayoutActions {

}

type ProjectLayoutProps = IProjectLayoutProps & IProjectLayoutActions;

class ProjectLayout extends React.PureComponent<ProjectLayoutProps, any> {

    constructor(props: ProjectLayoutProps) {
        super(props);
    }

    render() {
        const {
            loadingProject,
            project,
            loading,
            permissions,
            permission
        } = this.props;

        if (project && project.projectOutcomeId == 2) {
            let isLoading: boolean = loadingProject == undefined || loading == undefined || loadingProject || loading;
            // view from the trial menu 
            return <RestrictedLayout
                permission={permission}
                subMenuTitle={project ? project.shortDisplay : ""} 
                subMenuItems={isLoading || !project ? [] : TrialSubMenu(project.id, permissions)}
                sub2MenuItems={isLoading || !project ? [] : TrialProjectSubMenu(project.id, permissions)}
                loading={isLoading}
            >
                {this.props.children}
            </RestrictedLayout>;
        }

        return <RestrictedLayout
            permission={permission}
            subMenuTitle={project ? project.display : ""}
            subMenuItems={loadingProject == undefined || !project ? [] : ProjectSubMenu(project.id, permissions)}
            loading={loadingProject || loading}
        >
            {this.props.children}
        </RestrictedLayout>;
    }

}


const mapStateToProps = (state: ITmdState, ownProps: ProjectLayoutProps): IProjectLayoutProps => {

    let project: Dtos.Project | undefined = !(state.projects.formData instanceof Array) ? state.projects.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        permissions: permissions,
        permission: ownProps.permission,

        project: project!,

        loadingProject: state.projects.loadState && state.projects.loadState.status == RequestState.Pending,

        loading: ownProps.loading,
        children: ownProps.children,
    };
};

const mapDispatchToProps = (dispatch): IProjectLayoutActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(ProjectLayout);
